<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="aafb/admin/package/type/"
                       data-key="package_types"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template #item.name_en="{value}">
      <div v-html="value"></div>
    </template>
    <template #item.name_zh="{value}">
      <div v-html="value"></div>
    </template>
    <template #item.valid_from="{value}">
      {{ $parseDate(value) }}
    </template>
    <template #item.valid_until="{value}">
      {{ $parseDate(value) }}
    </template>
    <template v-slot:item.actions="{item}">
      <v-row>
        <v-col>
          <v-tooltip top>
            <template #activator="{on, attrs}">
              <v-btn icon
                     v-on="on"
                     v-bind="attrs"
                     @click="editItem(item)">
                <v-icon>fas fa-edit</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('edit') }}</span>
          </v-tooltip>
        </v-col>
        <v-col>
          <v-tooltip top>
            <template #activator="{on, attrs}">
              <v-btn icon
                     v-on="on"
                     v-bind="attrs"
                     @click="showTypePackage(item)">
                <v-icon>fas fa-cash-register</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('admin_acc_package_type.show_package') }}</span>
          </v-tooltip>
        </v-col>
        <v-col>
          <v-tooltip top>
            <template #activator="{on, attrs}">
              <v-btn icon
                     v-on="on"
                     v-bind="attrs"
                     @click="deleteItem(item)">
                <v-icon>fas fa-trash</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('admin_acc_package_type.delete') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";

export default {
  name: 'AdminPackageTypeList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        // {text: root.$t('admin_acc_package_type.name_en'), value: 'name_en', contains: true},
        // {text: root.$t('admin_acc_package_type.name_zh'), value: 'name_zh', contains: true},
        // {text: root.$t('admin_acc_package_type.valid_from'), value: 'valid_from', date_range: true},
        // {text: root.$t('admin_acc_package_type.valid_until'), value: 'valid_until', date_range: true},
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_acc_package_type.name_en'), value: 'name_en'},
      {text: root.$t('admin_acc_package_type.name_zh'), value: 'name_zh'},
      {text: root.$t('admin_acc_package_type.valid_from'), value: 'valid_from'},
      {text: root.$t('admin_acc_package_type.valid_until'), value: 'valid_until'},
      {text: root.$t('admin_acc_package_type.price'), value: 'price'},

      {text: '', value: 'actions', sortable: false},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const editItem = function (item) {
      emit('edit', item);
    };
    const showTypePackage = function (item) {
      emit('package', item);
    };
    const deleteItem = function (item) {
      if (confirm(root.$t('admin_acc_package_type.confirm_delete_msg'))) {
        root.$callAPI('aafb/admin/package/type/delete/', {
          type_id: item.id,
        }, () => {
          refresh();
        });
      }
    }


    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      showTypePackage,
      deleteItem,
    }
  }
}
</script>
